export default __webpack_public_path__ + "static/media/sample_1.8144ec1f.png";